import React from "react";
import { Text } from "@sanity/ui";

export const PREVIEW_ROWS = 20;

export const previewRows = <T,>(rows: T[]): T[] => rows.slice(0, PREVIEW_ROWS);

export const PreviewNotice: React.FC<{ total: number }> = ({ total }) => {
  if (total <= PREVIEW_ROWS) return null;

  return (
    <Text muted size={1} style={{ margin: "10px" }}>
      Showing {PREVIEW_ROWS} of {total} items. Download the file to see all
      items.
    </Text>
  );
};
